import request from '@/request';

/**
 * 获取任务信息
 * @param {*} taskId 
 */
export function getTaskInfo(taskId) {
  return request({
    url: `/api/system/tasks/${taskId}/auth`
  })
}

/**
 * 获取任务日志信息
 * @param {*} taskId 
 */
export function getTaskLogs(taskId) {
  return request({
    url: `/api/system/tasks/${taskId}/logs`
  })
}

/**
 * 获取任务流程图
 * @param {*} taskId 
 */
export function getTaskImage(taskId) {
  return request({
    url: `/api/system/tasks/${taskId}/image/jpeg`
  })
}

/**
 * 获取任务按钮
 * @param {*} taskId 
 */
export function getTaskButtons(taskId) {
  return request({
    url: `/api/system/tasks/${taskId}/forms`
  })
}

/**
 * 处理任务
 * @param {*} taskId 
 */
export function doneTask(taskId, data) {
  return request({
    url: `/api/system/tasks/${taskId}/process`,
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/components/Task/api.js